import App from './App'
import { startWorker } from './mocks/browser'
import 'prove-common/styles/index.css'
import { bootstrapApp } from 'prove-common/bootstrap'
import { BASE_URL } from './constants'

await bootstrapApp({
  appId: 'proveadmin',
  App,
  baseUrl: BASE_URL,
  startWorker,
  testRoles: ['admin'],
  testUserName: 'Testbruker (admin)'
})
